import { useMemo } from "react";
import { FeedbackType } from "../../../API";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import IconButton from "@mui/material/IconButton";

export default function FeedbackButton({
  type,
  feedback,
  isDisabled,
  onClick,
  className,
  ariaLabel,
}: {
  type: "up" | "down";
  feedback: FeedbackType | undefined;
  isDisabled: boolean;
  onClick?: () => void;
  className: string;
  ariaLabel: string;
}) {
  const isSelected =
    type === "up"
      ? feedback === FeedbackType.POSITIVE
      : feedback === FeedbackType.NEGATIVE;

  const color = isDisabled ? "disabled" : type === "up" ? "primary" : "error";

  const Icon = useMemo(() => {
    if (type === "up") return isSelected ? ThumbUpIcon : ThumbUpOutlinedIcon;

    return isSelected ? ThumbDownIcon : ThumbDownOutlinedIcon;
  }, [type, isSelected]);

  return (
    <IconButton
      aria-label={ariaLabel}
      className={className}
      onClick={onClick}
      disabled={isDisabled}
      sx={{
        cursor: isDisabled ? "default !important" : "pointer",
        "& .MuiSvgIcon-root": {
          cursor: isDisabled ? "default !important" : "pointer",
        },
        "&.Mui-disabled": { cursor: "default !important" },
        "&.Mui-disabled .MuiSvgIcon-root": { cursor: "default !important" },
      }}
    >
      <Icon color={color} />
    </IconButton>
  );
}
